export function toMicroseconds(milliseconds) {
    return Math.trunc(milliseconds * 1000);
}
export function currentTimeInSeconds() {
    return Math.floor(Date.now() / 1000);
}
export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const HOUR_MINUTES = 60;
export const DAY_MINUTES = 24 * HOUR_MINUTES;
export const WEEK_MINUTES = 7 * DAY_MINUTES;
export const YEAR_MONTHS = 12;
